import React from "react";
import Helmet from "react-helmet";

class Legal extends React.Component {

    componentDidUpdate(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    render() {
		const dtm_deviceCheck = /Mobile/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
		const dataLayer = {
			"formName": "",
			"formStatus": "",
			"formisSubmitted": false,
			"deviceType": dtm_deviceCheck,
			"siteBusinessUnit": "Tutuwa",
			"siteErrorCode": "",
			"siteLanguage": "English",
			"siteCountry": "South Africa",
			"websiteName": "Tutuwa Foundation",
			"websiteNameCode": "TT",
			"pageCategory": "Legal",
			"pageName": "Legal",					
			"pageSubSection1": "Legal",
			"pageSubSection2": "",
			"pageSubSection3": "",
			"pageSubSection4": ""
		};
        return (

            <div className="legal">

                <Helmet>
                    <title>The Standard Bank Tutuwa Community Foundation: Legal </title>
                    <meta name="title" content="The Standard Bank Tutuwa Community Foundation: Legal "/>
                    <meta name="description" content="We aim to help young South Africans reach their full potential and make an active contribution to their community."/>
                    <meta name="keywords" content="Standard bank; tutuwa foundation; South African youth; investing in South Africa’s youth; social impact initiatives; economic development; investing in social impact bonds; impact investing; thought leadership; economic growth and development; industrial development; department of trade, industry and competition; youth empowerment; black economic empowerment"/>
                    <meta name="robots" content="index, follow"/>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
                    <meta name="language" content="English"/>
					<script type="text/javascript" language="javascript">{`
						var dataLayer = ${JSON.stringify(dataLayer)};
					`}</script>
					{/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-4d4e0baaa532-development.min.js" async></script> */}
					{/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-0ec4707af30e-staging.min.js" async></script> */}
					<script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-e88652abdf04.min.js" async></script> 
                </Helmet>

				
				<div className="content-wrapper">

					<div className="content">

						<h2>PRIVACY STATEMENT</h2>

						<p><b>Privacy statement of The Standard Bank Tutuwa Community Foundation NPC (the Foundation), an independent</b>, non-profit company dedicated to alleviating poverty and supporting the socio-economic development of South Africa’s young people. </p>

						<h4>What is the purpose and scope of this statement?</h4>

						<p>The purpose of this statement is to inform you about how we collect, use, store, make available, disclose, update, safeguard, destroy or otherwise deal with the processing of your personal information and also to explain your rights relating to the privacy of your personal information and how the law protects you.</p>
						<p>We use the information for any of the purposes set out in this statement where we have lawful ground to do so and apply adequate data protection. Protecting the privacy, confidentiality and security of your personal information is very important to the Foundation as it is critical for us to maintain your trust and act in the right way to meet your needs. We have therefore adopted the Standard Bank Group policies and procedures to ensure that your personal information is protected.</p>
						
						<h4>What is personal information and what types of personal information do we collect?</h4>
						
						<p>Personal information is any information from which you can be identified. The personal information we may collect about you for the purpose of our key thematic areas and other focus areas may include:</p>

						<p>
							<ul>
							<li>name, age, gender, sex, and identifying numbers;</li>
							<li>physical and email addresses and contact numbers;</li>
							<li>online identifiers and your online behaviour such as cookies and IP addresses;</li>
							<li>engagements with us including, transactions, requests, queries, applications and complaints;</li>
							<li>financial information including with regard to financial behaviour, goals and needs;</li>
							<li>internal reports and other derivative data based on the personal information we collect;</li>
							<li>other personal information including race or ethnic origin, criminal history and behaviour. </li>

							</ul>
						</p>


						<h4>How do we collect your personal information?</h4>


						<p>We will collect personal information directly from you or by telephone, email or through online channels such as the Foundation website. 
						We collect personal information directly from you for the purpose of conducting the foundation’s activities.</p>
						<p>If you are a third-party service provider or Partner, we may collect personal information about you as a data subject in order to ensure that the business relationship and matters relating to the agreement between you and us can be fulfilled. You warrant that, if you provide us with any personal information about other persons, such as your directors for the purpose of screening, you are authorised to share their personal information with us for purposes set out in this statement.</p>
						
						<p>Providing your personal information to us is usually voluntary. However, it may be mandatory under certain circumstances, for example when you apply for funding or to comply with anti-money laundering legislation. If you fail to provide us with your personal information when requested, we may not be able to provide the funding to you or comply with our legal obligations.</p>
						
						<h4>Why do we process your personal information?</h4>

						<p>Our responsibilities to you are very important to us and we aim to provide you with support during our contractual period. We may process your personal information for any of the reasons outlined below.</p>
						
						<p>
							<ul>
								<b>Contract requirements</b><br />
								We may need to process your personal information if required for the conclusion and performance under a contract with you for funding purposes. 
								
				
							</ul>
						</p>

						<p>
							<ul>
								<b>Lawful obligations</b> <br />
								We may need to process your personal information for the following purposes:<br />
								
								<li>To complete integrity and business conduct checks required for compliance purposes including due diligence and onboarding processes, monitoring and assurance evaluation reviews and conduct sanctions screening against any sanctions lists.</li>
								<li>To comply with other risk management, regulatory and legislative requirements.</li>
								<li>To comply with voluntary and mandatory codes of conduct.  </li>
								<li>To detect, prevent and report theft, money laundering, terrorist financing, corruption or other potentially illegal activity, or activity that could lead to loss.</li>
								<li>To process and settle transactions and payments.</li>
								<p>To conduct research and analysis (which includes dashboards and impact reports). </p>

								

								<b>Legitimate interest</b> <br />
								The Foundation may process your personal information in the regular management of its business and to protect the interests of the Foundation. The Foundation may process your personal information in order to: <br />
								
								<li>Maintain, monitor, improve and develop our business policies, systems and controls;</li>
								<li>Maintain and improve data quality;</li>
								<li>Respond to partner enquiries and communications; Manage business emergencies and stress events;</li>
								<li>Process and settle transactions and payments;</li>
								<li>Meet record-keeping obligations;</li>
								<li>Conduct research and analysis </li>
								<li>Achieve other related purposes (bi-annual partner reporting).</li>

								
								<p></p>
								<b>Consent</b> <br />	
								In addition to the reasons given above, we may process your personal information where we have your specific consent for a defined purpose. We will also seek your consent where applicable laws require it. <br /><br />
								We will store your personal information according to our defined retention schedules and thereafter delete it.
								
				
							</ul>
						</p>

						<h4>Where will we process your personal information?</h4>

						<p>Due to the nature of the Foundation’s business, we may process your personal information and we comply with the minimum data protection standards in South Africa. We will only process personal information and share your personal information with our third party service providers we conduct business with. </p>
						
					
						<p><b>How long do we retain your personal information</b></p>

						<p>We retain your personal information in line with our legal and regulatory obligations and for our business and operational purposes as highlighted above. </p>

						<p><b>How will we communicate with you?</b></p>

						<p>Besides in-person communication, we use email and phone calls to engage with you regarding our existing partnership. We may contact you through these means for monitor and evaluation purposes as set out in the contractual agreements.</p>

						<h4>When, how and with whom will we share your personal information?</h4>

						<p>We share information with third parties and auditors who we have contracted with and other authorities as required by law.</p>
						<p>We take extra care when we transfer or share information and will enter into suitable contracts with the trusted parties with whom we share your information, thus ensuring your rights under relevant data protection legislation are upheld.</p>


						<h4>How is your personal information protected?</h4>


						<p>The security of your personal information is important to the Foundation, and we take appropriate, reasonable technical and organisational measures to prevent loss, destruction of and damage or unlawful access to your personal information by unauthorised parties. However, you must not share or send us any personal information through unauthorised channels, as these are not a secure way of communication and carry a risk of interception and unauthorised access. You should only share personal information through our authorised channels.</p>


						<h4>What are your rights?</h4>
						<p>We value your trust and want you to be familiar with your rights under the legislation and to know how you can exercise them in your interactions with the Foundation. You have the right to:</p>
						<p>

							<ul>

							<li>establish whether the Foundation holds your personal information and to request access to the personal information we hold about you, </li>
							<li>request, where necessary, the correction, destruction or deletion of your personal information;</li>
							<li>object to our processing your personal information, where applicable;</li>
							<li>be notified that your personal information is being collected by us or has been accessed or acquired by an unauthorised person;</li>
							<li>request reasons or make a representation to us if your application for funding is refused.</li>

							</ul>

						</p>


											
						<h4>Use of cookies on our website</h4>

						<p>A “cookie” is a small text file that is stored on your computer, smartphone, tablet or other device when you visit a website or use an application. It helps to distinguish you from other users and contains specific information related to your use of our website or application, such as your preference settings, and helps the website or the application to recognise your device.</p>
					
						<p>Cookies help to make a website or app function better and make it easier for us to give you a better user experience on our online channels. To use or store cookie types that are not required for the functioning of the website or app and are optional, we will obtain your consent first.</p>

						<p>For this reason, we limit our use of cookies to:</p>
						<p>
						<ul>
							<li>providing you with a better online experience and tracking website performance; and</li>
							<li>helping us make our website more relevant to you.</li>	
							We use the following types of cookies on our online channels, such as our website.

							<li><b>Strictly necessary cookies</b></li>	

								These cookies are mandatory and are required for the effective operation and functioning of our website on your device. They enable you to use the website and the features on the website and cannot be switched off.

							<li><b>Functional cookies</b></li>	
							These cookies are also mandatory and allow the website to offer improved features and personalised experiences.  They may be set by us or by trusted third parties whose services we have added to our pages and cannot be switched off.

							<li><b>Performance cookies</b></li>	

							These are optional cookies that collect information about how you use the website but not any personal information. Performance information is anonymous and mostly statistical and is used to improve the performance of our website.

							<li><b>Session cookies</b></li>	

							These cookies are temporary and optional and only exist while you browse our website to remember your activities on the website. As soon as you close the website or move to a different website, the cookies are deleted.

							<li><b>Persistent cookies</b></li>	

							These are permanent, optional cookies that are stored on your device until they reach a set expiry date or until you delete them. They remember your preferences or actions on our website (or in some cases across different websites). We may use them for various reasons, for example to remember your preferences and choices when you use our website, or to display relevant advertising campaigns to you.

							<li><b>First-party cookies</b></li>	

							These are cookies that we create and store when you use our website and relate to information obtained directly from you.

							<li><b>Third-party cookies</b></li>	

							These cookies are owned and created by a third party that provides a service to us such as social media sharing, website analytics or content marketing. These cookies are intended to collect information directly from you by us and we share the personal information with the third party through the cookies that the third party stores on our website.


						</ul>
						</p>
						<p>Once you select your cookie preferences you can always change them later by enabling or disabling them here:</p>

						<div style={{width: "100%", marginBottom: "15px"}}><button id="ot-sdk-btn" class="ot-sdk-show-settings">Manage Cookies</button></div>
						
						<h4>General</h4>

						<p>We may change this statement from time to time in accordance with changes in our strategy or regulatory requirements. We will make reasonable efforts to notify you through suitable communication channels. The latest copy of this statement is available at <a href="/legal">www.tutuwafoundation.org/legal</a></p>

						<p>Should you have any queries relating to the processing of your personal information by the Standard Bank Tutuwa Community Foundation NPC, please contact our Information Officer at <a href="mailto:Tutuwafoundation@standardbank.co.za">tutuwafoundation@standardbank.co.za</a></p>

						{/* <p>After engaging us and should your queries still not be addressed to your satisfaction, you have the right to lodge a formal complaint with the SA Information Regulator using Form 5, available at <a href="www.inforegulator.org.za">www.inforegulator.org.za</a>.</p> */}

					</div>
					

				</div>
				

            </div>

		);
		
	}
	
}

export default Legal;
